//const env = process.env.NODE_ENV;

const Setting = {
    // 页面切换时，是否显示模拟的进度条
    showProgressBar: true,
    // Cookies 默认保存时间，单位：天
    cookiesExpires: 1,
};

export default Setting;
